<h2 mat-dialog-title style="text-align: center;">
    {{ titulo }}
</h2>
<div mat-dialog-content class="center">
    {{ mensaje }}
</div>

<div mat-dialog-actions style="text-align: right;">
    <button  mat-raised-button color="primary" (click)="close()">Ok</button>
</div>